import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const itemStyle = {
  borderRadius: 8
}

export const Title = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: ${tokens.color.text.primary};
`
